import { isDisabled } from 'app/infrastructure/data/date';
import { SavedReportDashboard } from './types-store';

export const normalizeSequence = (items?: SavedReportDashboard[]): SavedReportDashboard[] => {

  return [...(items || [])]
    .sort((item1, item2) => (item1.sequence ?? 0) === (item2.sequence ?? 0)
      ? (isDisabled(item1.disabled) ? 1 : 0) - (isDisabled(item2.disabled) ? 1 : 0)
      : (item1.sequence ?? 0) - (item2.sequence ?? 0))
    .map((item, index) => item.sequence === index + 1
      ? item
      : {
        ...item,
        sequence: index + 1
      }
    );
};
